/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Danger_Zone_TitleInputs */

const es_user_profile_danger_zone_title = /** @type {(inputs: User_Profile_Danger_Zone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de peligro`)
};

const en_user_profile_danger_zone_title = /** @type {(inputs: User_Profile_Danger_Zone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {User_Profile_Danger_Zone_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_danger_zone_title = /** @type {((inputs?: User_Profile_Danger_Zone_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Danger_Zone_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_danger_zone_title(inputs)
	return en_user_profile_danger_zone_title(inputs)
});
export { user_profile_danger_zone_title as "user.profile.danger_zone.title" }